<div class="container">
    <button [disabled]="isLoading" class="mb-5"  mat-raised-button (click)="onBackClicked()">Back
        <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="row mb-5">
        <h1 class="text-center">Call Details</h1>
    </div>

    <div class="row">
        <div class="col-6">
            <h2>Information</h2>
            <p><span class="fw-bold">Call Date:</span> {{formatDate(callLog.startTime)}}</p>
            <p><span class="fw-bold">Outcome:</span> {{callLog.outcome}}</p>
            <p><span class="fw-bold">User Sentiment:</span> {{callLog.userSentiment}}</p>
            <p><span class="fw-bold">Caller Phone:</span> {{callLog.callerPhoneNumber}}</p>
        </div>

        <div class="col-6">
            <h2>Summary</h2>
            <p>{{callLog.summary}}</p>
        </div>
    </div>
    
    <mat-divider class="mt-5 mb-5"></mat-divider>
    
    <div class="row">
        <div class="col-6">
            <h2>Listen to audio</h2>
            <audio controls>
                <source [src]="callLog.recording">
            </audio>
        </div>

        <div class="col-6">
            <h2>Transcript</h2>
            <mat-form-field appearance="outline" class="w-100 mb-5">
                <textarea rows="7" [readonly]="true" matInput class="w-100" type="text" [(ngModel)]="callLog.transcript"></textarea>
            </mat-form-field>
        </div>
    </div>

    <mat-divider class="mt-5 mb-5"></mat-divider>

    <button (click)="onRemoveClicked()" [disabled]="isLoading" class="w-25 d-block mx-auto" mat-raised-button color="warn">
        <span *ngIf="!isLoading">
            Delete
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</div>